<template>
    <form-modal
        ref="formModal"
        :handle-hide="cleanModal"
        :v="$v.modalSchedule"
        :title="i18nTitleModal"
        :in-editing="isEdit"
        size="xl"
        :handle-close="handleCancel"
    >
        <template v-slot:form>
            <form @submit.prevent="handleOk">
                <confirmation-form-modal
                    ref="confirmationFormModal"
                    :title="i18nSchedule"
                    :operation="isEdit ? modalOperation : confirmationOperation"
                />
                <feedback-modal
                    ref="feedbackModal"
                    :title="i18nSchedule"
                />
                <b-row v-if="isScheduleCreated && !isEdit" class="mb-2">
                    <div class="col-sm-6 form-inline"> </div>
                    <div class="col-sm-6">
                        <div class="text-sm-right">
                            <edit-label-button
                                :title="i18nSchedule"
                                :disabled="submitLoading || isEditDisabledByDate"
                                @onClick="enableEditIfAllowed"
                            />
                        </div>
                    </div>
                </b-row>
                <b-tabs
                    id="schedule-tabs"
                    v-model="tabIndex"
                    class="tabs-pdv"
                    @activate-tab="onTabActivate"
                >
                    <!-- Informações -->
                    <b-tab :title="i18nInformation">
                     
                        <b-row>
                            <b-col md="4">
                                <b-form-group
                                    :label="i18nAction"
                                    class="required label-pdv"
                                    label-for="modal-action"
                                    :invalid-feedback="getI18n('ERROR_CODES.invalid_action')"
                                >
                                    <multiselect
                                        v-model="actionSelected"
                                        :options="actionOptions"
                                        track-by="value"
                                        label="text"
                                        :searchable="false"
                                        :show-labels="false"
                                        :disabled="!isEdit"
                                        :placeholder="i18nAction"
                                        :allow-empty="false"
                                        :class="validationClass($v.modalSchedule.action)"
                                        @input="clearResponseError('action', 'modalSchedule'); $v.modalSchedule.action.$touch()"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group
                                    :label="i18nDate"
                                    class="required label-pdv"
                                    label-for="modal-date"
                                    :invalid-feedback="getI18n('ERROR_CODES.invalid_date')"
                                >
                                    <date-picker
                                        id="modal-date"
                                        :value.sync="$v.modalSchedule.date.$model"
                                        :class="validationClass($v.modalSchedule.date)"
                                        :disabled="!isEdit"
                                        :disable-clean-button="false"
                                    />

                                    <!--
                                      Se o seu DatePicker NÃO suportar v-model, use isto:
                                      <date-picker
                                        :value="$v.modalSchedule.date.$model"
                                        @input="$v.modalSchedule.date.$model = $event"
                                      />
                                    -->
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group
                                    :label="'Aplicar em: '"
                                    class="required label-pdv"
                                    label-for="modal-filter-type"
                                    :invalid-feedback="getI18n('ERROR_CODES.invalid_filter_type')"
                                >
                                    <multiselect
                                        v-model="filterTypeSelected"
                                        :options="filterTypeOptions"
                                        track-by="value"
                                        label="text"
                                        :searchable="false"
                                        :show-labels="false"
                                        :disabled="!isEdit"
                                        :placeholder="i18nFilterType"
                                        :allow-empty="false"
                                        :class="validationClass($v.modalSchedule.filter_type)"
                                        @input="onFilterTypeChange(); clearResponseError('filter_type', 'modalSchedule'); $v.modalSchedule.filter_type.$touch()"
                                    />
                                </b-form-group>
                            </b-col> 
                            <b-row>
                           
                        </b-row>
                        </b-row>
                      
                        <b-row>
                            
                        </b-row>

                        <b-row>
                            <b-col md="12">
                                <b-form-group
                                    :label="i18nDescription"
                                    class="label-pdv"
                                    label-for="modal-description"
                                    :invalid-feedback="getI18n('ERROR_CODES.invalid_description')"
                                >
                                    <b-form-textarea
                                        id="modal-description"
                                        v-model.trim="$v.modalSchedule.description.$model"
                                        class="input-pdv-blue"
                                        name="description"
                                        :state="validateField('description', 'modalSchedule')"
                                        :placeholder="i18nDescription"
                                        :disabled="!isEdit"
                                        rows="3"
                                        max-rows="6"
                                        @blur="$v.modalSchedule.description.$touch"
                                        @input="clearResponseError('description', 'modalSchedule')"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
 
                        <b-row v-if="actionSelected && actionSelected.value === 'lock_checkin'">
                            <b-col md="12">
                                <b-form-group class="label-pdv">
                                    <b-form-checkbox
                                        v-model="$v.modalSchedule.block_app.$model"
                                        :disabled="!isEdit"
                                        name="block_app"
                                    >
                                        {{ i18nBlockApp }}
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="actionSelected">
                            <b-col md="12" class="text-center">
                                <b-alert
                                    :variant="actionMessageVariant"
                                    show
                                >
                                    {{ actionMessage }}
                                </b-alert>
                            </b-col>
                        </b-row>
                        <b-row v-if="isScheduleCreated && (modalSchedule.created_by || modalSchedule.updated_by)">
                            <b-col md="12">
                                <small class="text-muted">
                                    {{ i18nCreatedBy }}: {{ modalSchedule.created_by || '-' }} ({{ modalSchedule.created_at || '-' }})
                                    <span v-if="modalSchedule.updated_by"> | {{ i18nUpdatedBy }}: {{ modalSchedule.updated_by }} ({{ modalSchedule.updated_at || '-' }})</span>
                                </small>
                            </b-col>
                        </b-row>
                        <b-row v-if="isScheduleCreated && isEditDisabledByDate">
                            <b-col md="12">
                                <b-alert variant="warning" show>
                                    {{ i18nEditAfterDateNotAllowed }}
                                </b-alert>
                            </b-col>
                        </b-row>
                    </b-tab>

                    <!-- Filtro -->
                    <b-tab
                        :title="i18nFilter"
                        :disabled="!isInfoTabValid && !isScheduleCreated"
                    >
                        <b-row v-if="!isInfoTabValid && !isScheduleCreated">
                            <b-col md="12">
                                <b-alert variant="warning" show>
                                    {{ getI18n(i18nKey, 'MESSAGES.complete_info_tab') }}
                                </b-alert>
                            </b-col>
                        </b-row>
                        <!-- <b-row>
                            <b-col md="6">
                                <b-form-group
                                    :label="i18nFilterType"
                                    class="required label-pdv"
                                    label-for="modal-filter-type"
                                    :invalid-feedback="getI18n('ERROR_CODES.invalid_filter_type')"
                                >
                                    <multiselect
                                        v-model="filterTypeSelected"
                                        :options="filterTypeOptions"
                                        track-by="value"
                                        label="text"
                                        :searchable="false"
                                        :show-labels="false"
                                        :disabled="!isEdit"
                                        :placeholder="i18nFilterType"
                                        :allow-empty="false"
                                        :class="validationClass($v.modalSchedule.filter_type)"
                                        @input="onFilterTypeChange(); clearResponseError('filter_type', 'modalSchedule'); $v.modalSchedule.filter_type.$touch()"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row> -->
                        <b-row v-if="modalSchedule.filter_type">
                            <b-col v-if="isEdit" class="col-sm-12 col-md-4">
                                <b-form-group
                                    :label="i18nFilter"
                                    label-for="add-filter-value-input"
                                    class="label-pdv"
                                >
                                    <multiSelectWithService
                                        :id="'add-filter-value-input'"
                                        :key="filterValueMultiselectKey"
                                        ref="filterValueMultiselect"
                                        v-model="filterValueName"
                                        :service="filterService"
                                        :searchable="true"
                                        :multiple="false"
                                        :disabled="submitLoading"
                                        :parameters="filterParameters"
                                        :selected-items-list="modalSchedule.filter_values"
                                        :enable-toggle="true"
                                        :placeholder="i18nFilterValuesPlaceholder"
                                        @remove-item="handleRemoveFilterValueFromDropdown"
                                    />
                                </b-form-group>
                                <!-- <b-form-group
                                    class="label-pdv"
                                >
                                    <div class="d-flex align-items-center">
                                        <label class="mb-0 mr-2" for="add-all-users-toggle">
                                            {{ i18nAddAllUsers }}
                                        </label>
                                        <b-form-checkbox
                                            id="add-all-users-toggle"
                                            v-model="addAllUsers"
                                            switch
                                            size="lg"
                                            class="ml-2 mb-2"
                                            :disabled="submitLoading"
                                            @change="handleAddAllUsersToggle"
                                        />
                                    </div>
                                    <small class="text-muted text-small mt-3">
                                        ({{ i18nAddAllUsersDescription }})
                                    </small>
                                </b-form-group> -->
                            </b-col>
                            <b-col :class="isEdit ? 'col-sm-12 col-md-8' : 'col-sm-12 col-md-12'">
                                <data-mode-vuetable
                                    ref="filterValueVuetable"
                                    v-model="modalSchedule.filter_values"
                                    :fields="userChildrenActionFields"
                                    :display-delete-button="isEdit"
                                    :disabled="submitLoading"
                                    small
                                    @onClickDelete="handleRemoveFilterValue"
                                />
                            </b-col>
                        </b-row>
                        <b-row v-if="isInfoTabValid || isScheduleCreated">
                            <b-col md="12">
                                <div class="schedule-preview-impact mb-2">
                                    <strong class="d-block mb-1">{{ getI18n(i18nKey, 'MESSAGES.preview_impact_title') || 'Prévia do impacto' }}</strong>
                                    <b-alert v-if="previewImpactLoading" variant="light" show class="mb-0 d-flex align-items-center">
                                        <b-spinner small class="mr-2" />
                                        {{ getI18n(i18nKey, 'MESSAGES.preview_impact_loading') || 'Calculando preview...' }}
                                    </b-alert>
                                    <b-alert v-else-if="previewImpactMessage" variant="info" show class="mb-0">
                                        {{ previewImpactMessage }}
                                    </b-alert>
                                    <small v-else class="text-muted">
                                        {{ getI18n(i18nKey, 'MESSAGES.preview_impact_hint_filter_tab') || 'Selecione os valores do filtro acima para ver quantos usuários e roteiros serão afetados.' }}
                                    </small>
                                </div>
                            </b-col>
                        </b-row>
                    </b-tab>
                </b-tabs>
            </form>
        </template>

        <template v-slot:footer>
            <div v-if="isEdit" class="d-flex justify-content-center">
                <cancel-button
                    ref="cancelButton"
                    child-class="col-sm-4 float-left"
                    :disabled="submitLoading"
                    @onClick="handleCancel"
                />
                <save-button
                    v-if="showNextButton"
                    ref="nextButton"
                    child-class="col-sm-4 float-right ml-3"
                    :title="i18nNext"
                    :disabled="!canGoToNextTab || submitLoading"
                    @onClick="goToNextTab"
                />
                <save-button
                    v-else-if="showAddButton"
                    ref="okButton"
                    child-class="col-sm-4 float-right ml-3"
                    :title="i18nSave"
                    :busy="submitLoading"
                    :disabled="!isAllTabsValid || submitLoading"
                    @onClick="handleOk"
                />
            </div>
        </template>
    </form-modal>
</template>

<script>
import FormModal from '@components/FormModal'
import { required, maxLength } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import SchedulesService from '@src/services/SchedulesService.js'
import validationMixin from '@src/mixins/validation'
import swalFeedback from '@src/mixins/swalFeedback'
import DatePicker from '@src/components/DatePicker'
import MultiSelectWithService from '@src/components/multiSelectWithService'
import ConfirmationFormModal from '@src/components/ConfirmationFormModal'
import FeedbackModal from '@src/components/FeedbackModal'
import CancelButton from '@/src/components/CancelButton'
import SaveButton from '@/src/components/SaveButton'
import EditLabelButton from '@/src/components/EditLabelButton.vue'
import DataModeVuetable from '@/src/components/DataModeVuetable.vue'
import RolesService from '@src/services/RolesService'
import { SCHEDULE_ACTION_VALUES } from '@src/constants/scheduleActions'
import userChildrenActionFields from '@src/fields/childrens/userChildrenActionFields'
import moment from 'moment'

const i18nCommon = 'COMMON'
const i18nKey = 'SCHEDULES'

const emptySchedule = () => ({
    id: 0,
    date: null,
    description: '',
    action: '',
    filter_type: '',
    filter_values: [],
    block_app: true,
})

// clone "seguro" (shallow + arrays)
const cloneSchedule = (val) => {
    const cloned = {
        ...emptySchedule(),
        ...(val || {}),
    }
    
    // Garantir que filter_values seja um array de objetos
    if (val && val.filter_values) {
        cloned.filter_values = val.filter_values.map(fv => {
            // Se já é um objeto completo, retornar como está
            if (typeof fv === 'object' && fv !== null && fv.id !== undefined) {
                return { ...fv }
            }
            // Se é apenas um ID, criar um objeto mínimo (será preenchido depois se necessário)
            // Mas normalmente a API retorna objetos completos
            return typeof fv === 'object' && fv !== null ? { ...fv } : { id: fv }
        })
    } else {
        cloned.filter_values = []
    }
    
    return cloned
}

export default {
    components: {
        FormModal,
        Multiselect,
        DatePicker,
        MultiSelectWithService,
        DataModeVuetable,
        ConfirmationFormModal,
        FeedbackModal,
        CancelButton,
        SaveButton,
        EditLabelButton,
    },
    mixins: [
        validationMixin,
        swalFeedback,
        userChildrenActionFields,
    ],
    props: {
        modalIsEdit: {
            required: true,
            type: Boolean,
        },
        modal: {
            type: Object,
            default: () => emptySchedule(),
        },
        callback: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            i18nCommon,
            i18nKey,

            // ✅ não referencia direto o prop
            modalSchedule: cloneSchedule(this.modal),

            isEdit: false,
            submitLoading: false,

            // (se você usa isso pro cancel, talvez renomear pra algo mais coerente)
            confirmationOperation: 'deleted',

            tabIndex: 0,
            promotorRoleIds: [],
            supervisorRoleId: null,
            actionOptions: [],
            filterValueName: '',
            addAllUsers: false,
            filterValuesLoaded: false,
            persistedFilterType: this.modal.filter_type || '',
            filterValuesRequestToken: 0,

            // ✅ reativo
            modalResponseErrors: {},
            previewImpactMessage: '',
            previewImpactLoading: false,
        }
    },
    computed: {
        isEditDisabledByDate() {
            if (!this.modalSchedule.date || !this.isScheduleCreated) return false
            const d = this.modalSchedule.date
            const dateStr = d instanceof Date
                ? moment(d).format('YYYY-MM-DD')
                : (typeof d === 'string' ? d.slice(0, 10) : '')
            if (!dateStr) return false
            const today = moment().format('YYYY-MM-DD')
            return dateStr <= today
        },
        isScheduleCreated() {
            return this.modalSchedule.id > 0
        },
        i18nTitleModal() {
            if (this.isScheduleCreated) {
                // Sempre mostrar "Editar Agendamento" quando está editando um agendamento existente
                return `${this.getI18n(i18nCommon, 'edit')} ${this.i18nSchedule}`
            }
            return this.getI18n(i18nKey, 'BUTTONS.new_schedule')
        },
        i18nSchedule() {
            return this.getI18n(i18nKey, 'TITLES.schedule')
        },
        i18nDate() {
            return this.getI18n(i18nKey, 'FIELDS.date')
        },
        i18nDescription() {
            return this.getI18n(i18nKey, 'FIELDS.description')
        },
        i18nAction() {
            return this.getI18n(i18nKey, 'FIELDS.action')
        },
        i18nInformation() {
            return this.getI18nModified({
                prefix: i18nCommon,
                suffix: 'info',
                modifier: 2,
            })
        },
        i18nFilter() {
            return this.getI18nModified({
                prefix: i18nCommon,
                suffix: 'filter',
                modifier: 1,
            })
        },
        i18nFilterType() {
            return this.getI18n(i18nKey, 'FIELDS.filter_type')
        },
        i18nFilterValues() {
            return this.getI18n(i18nKey, 'FIELDS.filter_values')
        },
        i18nUser() {
            return this.getI18nModified({
                prefix: 'USERS',
                suffix: 'TITLES.user',
                modifier: 1,
            }) || 'Usuário'
        },
        i18nFilterValuesPlaceholder() {
            return this.getI18n('PLACEHOLDERS', 'select_an_option') || 'Selecione...'
        },
        i18nAddAllUsers() {
            return this.getI18n(i18nKey, 'FIELDS.add_all_users') || 'Adicionar todos os Usuários'
        },
        i18nAddAllUsersDescription() {
            return this.getI18n(i18nKey, 'FIELDS.add_all_users_description') || 'Adiciona todos os usuários do filtro'
        },
        modalOperation() {
            return this.isScheduleCreated ? 'edited' : 'created'
        },
        actionSelected: {
            get() {
                return (
                    this.actionOptions.find(
                        (action) => action.value === this.modalSchedule.action
                    ) || null
                )
            },
            set(newValue) {
                if (typeof newValue === 'object' && newValue !== null) {
                    this.modalSchedule.action = newValue.value
                } else {
                    this.modalSchedule.action = newValue || ''
                }
            },
        },
        actionMessage() {
            if (!this.actionSelected) {
                return ''
            }
            const actionKey = `MESSAGES.${this.actionSelected.value}`
            return this.getI18n(i18nKey, actionKey)
        },
        actionMessageVariant() {
            if (this.actionSelected.value === 'justify_pos') {
                return 'info'
            }
            if (this.actionSelected.value === 'delete_route') {
                return 'danger'
            }
            if (this.actionSelected.value === 'lock_checkin') {
                return 'warning'
            }
            return 'info'
        },
        filterTypeSelected: {
            get() {
                return (
                    this.filterTypeOptions.find(
                        (type) => type.value === this.modalSchedule.filter_type
                    ) || null
                )
            },
            set(newValue) {
                if (typeof newValue === 'object' && newValue !== null) {
                    this.modalSchedule.filter_type = newValue.value
                } else {
                    this.modalSchedule.filter_type = newValue || ''
                }
            },
        },
        filterService() {
            if (this.modalSchedule.filter_type === 'regional') {
                return 'pos-regionals'
            }
            return 'users'
        },
        filterParameters() {
            const params = {
                per_page: 1000,
                page: 1,
                orderBy: 'name',
                sortedBy: 'asc',
                active: true,
            }
            if (this.modalSchedule.filter_type === 'promotor' && this.promotorRoleIds.length) {
                params.role_id = [...this.promotorRoleIds]
            } else if (this.modalSchedule.filter_type === 'supervisor' && this.supervisorRoleId) {
                params.role_id = [this.supervisorRoleId]
            }
            return params
        },
        isInfoTabValid() {
            return (
                this.modalSchedule.date !== null &&
                this.modalSchedule.action &&
                this.modalSchedule.action.trim().length > 0 &&
                this.modalSchedule.filter_type &&
                this.modalSchedule.filter_type.trim().length > 0
            )
        },
        isFilterTabValid() {
            return (
                Array.isArray(this.modalSchedule.filter_values) &&
                this.modalSchedule.filter_values.length > 0
            )
        },
        isAllTabsValid() {
            return (
                this.isInfoTabValid &&
                this.isFilterTabValid
            )
        },
        currentTabValidation() {
            switch (this.tabIndex) {
                case 0:
                    return this.isInfoTabValid
                case 1:
                    return this.isFilterTabValid
                default:
                    return false
            }
        },
        canGoToNextTab() {
            if (this.tabIndex === 1) {
                return false // Última tab
            }
            // Sempre permitir ir para a próxima tab (navegação livre)
            return true
        },
        showNextButton() {
            // Mostrar Próximo quando não estiver na última tab (criar e editar)
            return this.tabIndex < 1
        },
        showAddButton() {
            // Se mostrar botão próximo, não mostrar salvar
            if (this.showNextButton) {
                return false
            }
            // Mostrar Salvar apenas na última tab (criar e editar, igual outros fluxos)
            return this.tabIndex === 1
        },
        i18nNext() {
            return this.getI18n(i18nCommon, 'next')
        },
        i18nSave() {
            return this.getI18n(i18nCommon, 'save')
        },
        i18nBlockApp() {
            return this.getI18n(i18nKey, 'FIELDS.block_app') || 'Bloquear acesso app'
        },
        i18nCreatedBy() {
            return this.getI18n(i18nKey, 'FIELDS.created_by') || 'Criado por'
        },
        i18nUpdatedBy() {
            return this.getI18n(i18nKey, 'FIELDS.updated_by') || 'Alterado por'
        },
        i18nEditAfterDateNotAllowed() {
            return this.getI18n(i18nKey, 'MESSAGES.edit_after_date_not_allowed') || 'Não é permitido editar um agendamento após a data de execução.'
        },
        /** Remount user/region picker when role IDs resolve so `role_id` query updates. */
        filterValueMultiselectKey() {
            const t = this.modalSchedule.filter_type || ''
            if (t === 'regional') {
                return `filter-value-regional`
            }
            const pid = (this.promotorRoleIds || []).join(',')
            const sid = this.supervisorRoleId || ''
            return `filter-value-${t}-${pid}-${sid}`
        },
    },
    watch: {
        // ✅ quando o pai trocar o modal, atualiza o interno
        modal: {
            deep: true,
            handler(val) {
                this.modalSchedule = cloneSchedule(val)
                this.persistedFilterType = this.modalSchedule.filter_type || ''
            },
        },
        // Observar mudanças no tipo do filtro para limpar valores
        'modalSchedule.filter_type'(newType, oldType) {
            if (newType !== oldType) {
                // Limpar valores quando o tipo muda
                this.modalSchedule.filter_values = []
                // Limpar o valor selecionado no multiselect
                this.filterValueName = ''
                // Resetar toggle de adicionar todos
                this.addAllUsers = false
                this.filterValuesLoaded = false
                // Resetar validação do campo filter_values
                // A key no componente força a recriação e recarregamento automático
                this.$nextTick(() => {
                    if (this.$v.modalSchedule.filter_values) {
                        this.$v.modalSchedule.filter_values.$reset()
                    }
                })
            }
        },
        filterValueName(value) {
            if (value) {
                const index = this.modalSchedule.filter_values.findIndex(fv => {
                    const fvId = typeof fv === 'object' && fv !== null ? fv.id : fv
                    const valueId = typeof value === 'object' && value !== null ? value.id : value
                    return fvId === valueId
                })
                // Se o item já está na lista e enableToggle está ativo, não adicionar
                // O handleInput do multiSelectWithService já cuida da remoção
                if (index < 0) {
                    this.modalSchedule.filter_values.push(value)
                }
                this.filterValueName = ''
                if (this.$refs.filterValueMultiselect) {
                    this.$refs.filterValueMultiselect.$el.focus()
                }
            }
        },
        'modalSchedule.filter_values': {
            deep: true,
            handler() {
                if (this.tabIndex === 1 && this.isInfoTabValid) {
                    this.fetchPreviewImpact()
                }
            },
        },
    },
    validations: {
        modalSchedule: {
            date: {
                required,
            },
            description: {
                minLength(value) {
                    if (!value || value.trim().length === 0) {
                        return true
                    }
                    return value.trim().length >= 2
                },
                maxLength: maxLength(255),
            },
            action: {
                required,
            },
            filter_type: {
                required,
            },
            filter_values: {
                required,
                minLength(value) {
                    return Array.isArray(value) && value.length > 0
                },
            },
            block_app: {},
        },
    },

    created() {
        this.loadRoles()
        this.actionOptions = SCHEDULE_ACTION_VALUES.map((value) => ({
            value,
            text: this.getI18n(i18nKey, `ACTIONS.${value}`),
        }))
        this.filterTypeOptions = [
            { value: 'promotor', text: this.getI18n(i18nCommon, 'promotor') || 'Promotor' },
            { value: 'supervisor', text: this.getI18n(i18nCommon, 'supervisor') || 'Supervisor' },
            { value: 'regional', text: this.getI18n('POS', 'TITLES.regional') || 'Regional' },
        ]
    },
    methods: {
        async loadRoles() {
            try {
                const [promotor, promotorLider, supervisor] = await Promise.all([
                    RolesService.findRoleByExactName('promotor'),
                    RolesService.findRoleByExactName('promotor lider'),
                    RolesService.findRoleByExactName('supervisor'),
                ])
                this.promotorRoleIds = [promotor?.id, promotorLider?.id].filter(Boolean)
                this.supervisorRoleId = supervisor?.id ?? null
            } catch (error) {
                console.error('Erro ao carregar roles:', error)
            }
        },

        enableEditIfAllowed() {
            if (this.isEditDisabledByDate) {
                this.negativeFeedback(
                    this.getI18n('RESPONSES', 'something_wrong'),
                    this.i18nEditAfterDateNotAllowed
                )
                return
            }
            this.isEdit = true
        },

        showModal() {
            this.isEdit = this.modalIsEdit && !this.isEditDisabledByDate
            this.submitLoading = false
            this.tabIndex = 0
            this.filterValueName = ''
            this.filterValuesLoaded = false
            this.previewImpactMessage = ''
            this.previewImpactLoading = false
            this.resetValidation()

            this.$nextTick(() => {
                this.$refs.formModal.show()
                if (this.isAllTabsValid) {
                    this.fetchPreviewImpact()
                }
            })
        },

        resetValidation() {
            this.$nextTick(() => this.$v.$reset())
            this.clearAllResponseError()
            this.modalResponseErrors = {}
        },

        cleanModal() {
            this.filterValuesLoaded = false
            this.filterValuesRequestToken++
            this.modalSchedule = cloneSchedule(emptySchedule())
            this.tabIndex = 0
            this.resetValidation()
        },

        replaceModalData(data) {
            this.filterValuesLoaded = false
            this.filterValuesRequestToken++
            this.modalSchedule = cloneSchedule(data)
            this.persistedFilterType = this.modalSchedule.filter_type || ''
        },

        handleCancel() {
            if (this.isEdit) {
                // aqui você está usando o modal de confirmação “deleted” pra cancelar.
                // Se isso é intencional ok. Se não, troque confirmationOperation.
                this.$refs.confirmationFormModal.showModal(true, this.handleClose)
            } else {
                this.handleClose(true)
            }
        },

        handleClose(close) {
            if (!close) {
                return
            }
            this.resetValidation()
            this.$refs.formModal.hide()
        },

        handleOk() {
            if (this.isScheduleCreated && this.isEditDisabledByDate) {
                this.negativeFeedback(
                    this.getI18n('RESPONSES', 'something_wrong'),
                    this.i18nEditAfterDateNotAllowed
                )
                return
            }
            // Validar todas as tabs antes de salvar (criar e editar)
            if (!this.isAllTabsValid) {
                this.negativeFeedback(
                    this.getI18n('RESPONSES', 'something_wrong'),
                    this.getI18n(i18nKey, 'MESSAGES.complete_all_tabs')
                )
                return
            }
            this.$v.modalSchedule.$touch()
            if (!this.$v.modalSchedule.$invalid && !this.submitLoading) {
                this.$refs.confirmationFormModal.showModal(false, this.handleSubmit)
            }
        },

        async handleSubmit(submit) {
            if (!submit) return

            this.submitLoading = true

            const operation = this.isScheduleCreated ? 'edited' : 'created'
            try {
                const result = await this.createOrUpdateSchedule()
                const statusCode = String(result?.status || '')
                if (statusCode.charAt(0) === '2') {
                    this.successfulOperation(operation)
                } else {
                    this.modalResponseErrors = result?.data?.errors || {}
                    this.unsuccessfulOperation({ response: { data: result?.data, status: result.status } })
                }
            } catch (err) {
                if (err && err.response) {
                    this.modalResponseErrors = err.response.data?.errors || {}
                    this.unsuccessfulOperation(err)
                } else {
                    this.modalResponseErrors = {}
                    const title = this.getI18n('RESPONSES', 'something_wrong')
                    const text = err?.message || this.getI18n('RESPONSES', 'operation_not_possible')
                    this.negativeFeedback(title, text)
                }
            } finally {
                this.submitLoading = false
            }
        },

        async createOrUpdateSchedule() {
            const op = this.isScheduleCreated
                ? SchedulesService.update(this.modalSchedule.id, this.modalSchedule)
                : SchedulesService.create(this.modalSchedule)

            const response = await op
            this.replaceModalData(response.data.data)
            return response
        },

        getFriendlyErrorMessage(apiError) {
            const data = apiError?.response?.data ?? apiError?.data ?? {}
            let text = data.message
            if (!text && data.errors && typeof data.errors === 'object') {
                const firstKey = Object.keys(data.errors)[0]
                const firstArr = data.errors[firstKey]
                if (Array.isArray(firstArr) && firstArr[0]) {
                    text = firstArr[0]
                }
            }
            return text || this.getI18n('RESPONSES', 'operation_not_possible')
        },

        successfulOperation(operation) {
            this.$emit('refresh')
            this.resetValidation()
            this.isEdit = false
            // Fechar a modal após criação/edição bem-sucedida
            this.$refs.formModal.hide()
            // Limpar os dados da modal após fechar (usar nextTick para garantir que a modal feche primeiro)
            this.$nextTick(() => {
                this.cleanModal()
            })
            this.positiveFeedback(this.i18nSchedule, operation)
        },

        unsuccessfulOperation(apiError) {
            const title = this.getI18n('RESPONSES', 'something_wrong')
            const text = this.getFriendlyErrorMessage(apiError)
            this.negativeFeedback(title, text)
        },
        goToNextTab() {
            if (this.canGoToNextTab) {
                this.tabIndex++
            }
        },
        handleRemoveFilterValue(id) {
            const index = this.modalSchedule.filter_values.findIndex(fv => {
                const fvId = typeof fv === 'object' && fv !== null ? fv.id : fv
                return fvId === id
            })

            if (index > -1) {
                this.modalSchedule.filter_values.splice(index, 1)
                // Resetar validação
                this.$nextTick(() => {
                    if (this.$v.modalSchedule.filter_values) {
                        this.$v.modalSchedule.filter_values.$touch()
                    }
                })
            }
        },
        handleRemoveFilterValueFromDropdown(item) {
            if (!item) return
            
            const itemId = typeof item === 'object' && item !== null && item.id !== undefined ? item.id : item
            this.handleRemoveFilterValue(itemId)
            
            // Limpar o valor selecionado no multiselect
            this.filterValueName = ''
        },
        onFilterTypeChange() {
            // Resetar validação do campo filter_type
            this.$v.modalSchedule.filter_type.$touch()
            // O watcher vai cuidar de limpar valores e recarregar opções
            // Resetar toggle de adicionar todos
            this.addAllUsers = false
        },
        handleAddAllUsersToggle(value) {
            if (!value) {
                // Se desativar, não fazer nada (manter usuários já selecionados)
                return
            }

            // Usar as opções já carregadas no multiSelectWithService
            if (!this.$refs.filterValueMultiselect) {
                this.addAllUsers = false
                return
            }

            const allUsers = this.$refs.filterValueMultiselect.options || []
            
            if (allUsers.length === 0) {
                // Se não há opções carregadas, desativar o toggle
                this.addAllUsers = false
                return
            }
            
            // Adicionar apenas os que ainda não estão na lista
            allUsers.forEach(user => {
                const index = this.modalSchedule.filter_values.findIndex(fv => {
                    const fvId = typeof fv === 'object' && fv !== null ? fv.id : fv
                    return fvId === user.id
                })
                
                if (index < 0) {
                    this.modalSchedule.filter_values.push(user)
                }
            })
            
            // Resetar validação
            this.$nextTick(() => {
                if (this.$v.modalSchedule.filter_values) {
                    this.$v.modalSchedule.filter_values.$touch()
                }
            })
        },
        onTabActivate(newTabIndex) {
            // Prevenir acesso a tabs bloqueadas apenas no modo de criação
            if (newTabIndex === 1 && !this.isInfoTabValid && !this.isScheduleCreated) {
                this.$nextTick(() => {
                    this.tabIndex = 0
                    this.negativeFeedback(
                        this.getI18n('RESPONSES', 'something_wrong'),
                        this.getI18n(i18nKey, 'MESSAGES.complete_info_tab')
                    )
                })
                return
            }
            if (newTabIndex === 1) {
                this.loadFilterValues()
                this.fetchPreviewImpact()
            }
        },

        async fetchPreviewImpact() {
            if (!this.isFilterTabValid || !this.modalSchedule.date) {
                this.previewImpactMessage = ''
                this.previewImpactLoading = false
                return
            }
            const datePayload = SchedulesService.normalizePayload({
                date: this.modalSchedule.date,
            }).date
            const payload = {
                date: datePayload || null,
                filter_type: this.modalSchedule.filter_type,
                filter_values: this.getFilterValueIds(this.modalSchedule.filter_values),
            }
            if (!payload.date || !payload.filter_type || !payload.filter_values.length) {
                this.previewImpactMessage = ''
                this.previewImpactLoading = false
                return
            }
            this.previewImpactLoading = true
            this.previewImpactMessage = ''
            try {
                const res = await SchedulesService.previewImpact(payload)
                const data = res?.data?.data ?? res?.data ?? {}
                const users = data.affected_users_count ?? 0
                const items = data.affected_items_count ?? 0
                const template = this.getI18n(i18nKey, 'MESSAGES.preview_impact') || 'X usuário(s) / Y roteiro(s) serão afetados.'
                this.previewImpactMessage = template.replace('X', String(users)).replace('Y', String(items))
            } catch (e) {
                this.previewImpactMessage = ''
            } finally {
                this.previewImpactLoading = false
            }
        },

        getFilterValueIds(filterValues) {
            if (!Array.isArray(filterValues)) {
                return []
            }
            return filterValues.map((filterValue) =>
                typeof filterValue === 'object' && filterValue !== null && filterValue.id !== undefined
                    ? filterValue.id
                    : filterValue
            )
        },

        async loadFilterValues() {
            if (!this.modalSchedule.id || this.filterValuesLoaded) {
                return
            }
            const requestScheduleId = this.modalSchedule.id
            const requestFilterType = this.modalSchedule.filter_type || ''
            if (requestFilterType !== this.persistedFilterType) {
                return
            }
            const requestStartFilterValueIds = this.getFilterValueIds(this.modalSchedule.filter_values)
            const requestToken = ++this.filterValuesRequestToken
            this.filterValuesLoaded = true
            try {
                const response = await SchedulesService.fetchById(requestScheduleId, {})
                if (requestToken !== this.filterValuesRequestToken) {
                    return
                }
                if (this.modalSchedule.id !== requestScheduleId || this.modalSchedule.filter_type !== requestFilterType) {
                    return
                }
                const currentFilterValueIds = this.getFilterValueIds(this.modalSchedule.filter_values)
                if (JSON.stringify(currentFilterValueIds) !== JSON.stringify(requestStartFilterValueIds)) {
                    return
                }
                const data = response?.data?.data
                if ((this.modalSchedule.filter_type || '') !== requestFilterType) {
                    this.filterValuesLoaded = false
                    return
                }
                if (data && Array.isArray(data.filter_values)) {
                    this.modalSchedule.filter_values = data.filter_values.map((fv) =>
                        typeof fv === 'object' && fv !== null ? { ...fv } : { id: fv }
                    )
                }
            } catch (err) {
                if (requestToken === this.filterValuesRequestToken) {
                    this.filterValuesLoaded = false
                }
                console.error('Erro ao carregar filter_values:', err)
            }
        },
    },
}
</script>

<style>
#schedule-tabs .nav-link.disabled {
    background: #eaeaea;
}
</style>
